import './styles/global.scss';
import RequireAuth from './components/RequireAuth';
import {
  Routes,
  Route
} from 'react-router-dom';

import ClientLayout from './components/layout/ClientLayout';
import Home from './pages/home/Home';
import Menu from './pages/shishMenu/Menu';
import Galleries from './pages/media/galleries/Galleries';
import ContactPage from './pages/contact/ContactPage';
import TestimonialsPage from './pages/testimonials/TestimonialsPage';

import Login from "./pages/login/Login";

import Layout from './components/layout/Layout';
import Dashboard from './pages/dashboard/Dashboard';
import Testimonials from './pages/testimonials/Testimonials';
import Testimony from './pages/testimony/Testimony';
import Users from './pages/users/Users';


import Profile from './pages/profile/Profile';
import UnAuthorized from './pages/unauthorized/UnAuthorized';
import Missing from './pages/missing/Missing';
import AllImages from './pages/media/galleries/allImages/AllImages';
import HomeImages from './pages/media/galleries/homeImages/HomeImages';
import PoliciesLayout from './components/layout/PoliciesLayout';
import Terms from './pages/policies/Terms';
import Refund from './pages/policies/Refund';
import Privacy from './pages/policies/Privacy';
import GDPR from './pages/policies/GDPR';
import HouseRules from './pages/policies/HouseRules';

import AllVideos from './pages/media/videos/AllVideos';

const App = () => {

  return (

    <Routes>
      <Route path='/' element={<ClientLayout />}>
        <Route path='/' element={<Home />} />
        <Route path='/menu' element={<Menu />} />
        <Route path='/testimonyp' element={<TestimonialsPage />} />
        <Route path='/gallery' element={<Galleries />} />
        <Route path='/contact' element={<ContactPage />} />

        {/* POLICIES SECTION WITH OUTLET */}
        <Route path="/policies" element={<PoliciesLayout />}>
          <Route index element={<Terms />} /> {/* Default page */}
          <Route path="terms" element={<Terms />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="gdpr" element={<GDPR />} />
          <Route path="refund" element={<Refund />} />
          <Route path="house-rules" element={<HouseRules />} />
        </Route>

      </Route>

      <Route path='/cpanel/login' element={<Login />} exact />



      <Route path='cpanel/manager' element={<Layout />}>
        
        <Route path='unauthorized' element={<UnAuthorized />} exact />

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='dashboard' element={<Dashboard />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='profile' element={<Profile />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='testimonials' element={<Testimonials />} exact />
        </Route >

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='testimonials/:id' element={<Testimony />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin']} />}>
          <Route path='users' element={<Users />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='galleries' element={<AllImages />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='homeImgs' element={<HomeImages />} exact />
        </Route>

        <Route element={<RequireAuth allowedRoles={['Admin', 'Manager', 'User']} />}>
          <Route path='vclip' element={<AllVideos />} exact />
        </Route>

      </Route>

      <Route path='*' element={<Missing />} />
    </Routes>

  )

}

export default App;
